module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza202110.063b78b5.jpg";